import { useForm } from 'react-hook-form';

import { State } from '@/types';

import { TProgramForm } from '../types';

export function useProgramDrawerFormState() {
  const PROGRAM_FORM_DEFAULT_VALUES: TProgramForm = {
    state: State.Active,
    start_datetime: new Date(),
    end_datetime: null,
    name: '',
    channel_id: '',
    priority: null,
    language_id: '',
    language_transcription_id: '',
    program_classification: '',
    program_category_id: '',
    program_viewed_place_id: '',
    schedule: [],
    description: '',
    audience_program_source_id: '',
    uri: '',
    parameters: {
      enrichments: {
        stt: false,
        logos: false,
        peoples: false,
        ocr: false,
        advertising: false,
      },
      link_with_channel_enrichments: true,
      ai_clips_require_review: true,
    },
    legacy_id: null,
  };
  const form = useForm<TProgramForm>({
    mode: 'all',
    defaultValues: PROGRAM_FORM_DEFAULT_VALUES,
  });

  return { form, PROGRAM_FORM_DEFAULT_VALUES };
}
